import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import ToolsMarquee from '../components/ToolsMarquee';
import Mission from '../components/Mission';
import StatTiles from '../components/StatTiles';
import ServicesGrid from '../components/ServicesGrid';
import PricingTiers from '../components/PricingTiers';
import ManageGrow from '../components/ManageGrow';
import StrategistPanel from '../components/StrategistPanel';
import UpworkReviews from '../components/UpworkReviews';
import CoreValues from '../components/CoreValues';
import CTABanner from '../components/CTABanner';
import Footer from '../components/Footer';

const HomeHybrid = () => {
  return (
    <>
      <SEO
        title="Email Marketing & Automation Expert | Growth Hacking"
        description="Transform your email list into a predictable revenue engine. Expert Kit.com, ActiveCampaign & email automation services. 5-star rated on Upwork with 16+ client reviews."
        canonical="/"
      />
      <main className="bg-cream">
        <Hero />
        <ToolsMarquee />
        <Mission />
        <StatTiles />
        <ServicesGrid />
        <PricingTiers />
        <ManageGrow />
        <StrategistPanel />
        <UpworkReviews />
        <CoreValues />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
};

export default HomeHybrid;
